import React from 'react'
import Logic from './logic.js'
import Chessground from 'react-chessground'
import 'react-chessground/dist/styles/chessground.css'

const depths = {}
let count = 0

const positions = {}

function isWinning(move, color, logic, depth) {
  logic.makeMove(move);
  let fen = logic.fen()
  if (positions[fen]) {
    logic.undoMove();
    return positions[fen] === color
  }
  count = count + 1
  let otherColor = color === 'w' ? 'b' : 'w'
  if (!depths[depth]) {
    console.log(`reached depth ${depth}`);
    depths[depth] = true
  }
  let winner = logic.winner();
  let ret;
  if (winner) {
    ret = (winner === color);
  } else {
    let otherMoves = logic.colorMoves(otherColor);
    ret = otherMoves.every(move => !isWinning(move, otherColor, logic, depth + 1))
  }
  positions[fen] = ret ? color : otherColor;
  logic.undoMove();
  return ret;
}

class Game extends React.Component {
  // startingFen = '1n1n1n1n/8/8/8/8/8/8/4K3 w - - 0 1'
  startingFen = '3k4/8/8/8/8/8/8/P1P1P1P1 w - - 0 1'
  
  logic = new Logic(this.startingFen)
    
  state = {
    fen: this.startingFen,
    lastMove: null,
    resize_count: 0
  }

  winningMove = () => {
    // clear depths
    for (let k in depths) delete depths[k];
    let logic = new Logic(this.state.fen);
    let color = logic.turn();
    let moves = logic.colorMoves(color);
    console.log(`#valid moves: ${moves.length}`);
    let start = (new Date()).getTime();
    let moved;
    for (let move of moves) {
      if (isWinning(move, color, logic, 1)) {
        console.log(`about to play move ${move}`)
        console.log(`count: ${count}`)
        let stop = (new Date()).getTime();
        let took = stop - start;
        console.log(`took ${took}ms`);
        console.log(`that's about ${100 * took / count} us/move`);
        
        this.logic.makeMove(move);
        this.setState({ fen: this.logic.fen(), lastMove: [move.from, move.to] })
        moved = true;
        break;
      }
    }
    if (!moved) {
      console.log('no winning move');
      if (moves.length > 0) {
        let move = this.logic.moveWithLeastWinningCounters(moves, color, (move, color) => isWinning(move, color, this.logic, 0))
        // let move = this.logic.mostForwardMove(moves);
        this.logic.makeMove(move);
        this.setState({ fen: this.logic.fen(), lastMove: [move.from, move.to] })
      } else {
        console.log('no valid moves - i lost');
      }
    }
  }

  playWinningMoveIn500ms() {
    if (!this.logic.winner()) {
      console.log("going to play a move in 500ms")
      this.props.setThinking(true);
      setTimeout(() => {
	this.winningMove()
	this.props.setThinking(false);
      }, 500)
    } else {
      console.log("Not playing a (winning) move in 500ms b/c logic says there's already a winner")
    }
  }
  
  onMove = (from, to) => {
    let move = { from, to }
    console.log(move);
    this.logic.makeMove(move);
    this.setState({ fen: this.logic.fen(), lastMove: [move.from, move.to] })
    this.playWinningMoveIn500ms()
  }

  draggable = {
    showGhost: false
  }

  undoMove = () => {
    if (this.state.lastMove) {
      this.logic.undoMove()
      this.logic.undoMove()
      let last = this.logic.lastMove();
      let lastMove = last ? [ last.from, last.to ] : null;
      this.setState({ fen: this.logic.fen(), lastMove: lastMove })
    }
  }

  resize = () => {
    this.setState({ resize_count: this.state.resize_count + 1 });
    document.body.dispatchEvent(new Event('chessground.resize'));
  }
  
  componentDidMount(prevProps) {
    if (this.logic.turnColor() !== this.props.orientation) 
      setTimeout(() => this.playWinningMoveIn500ms(), 2000)
    window.addEventListener("resize", this.resize);
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.undoCounter < this.props.undoCounter) 
      this.undoMove()
    
    if (prevProps.resetCounter < this.props.resetCounter) {
      this.logic = new Logic(this.startingFen)
      this.setState({
        fen: this.startingFen,
        lastMove: null
      })
      if (this.logic.turnColor() !== this.props.orientation) 
        this.playWinningMoveIn500ms()
    }

    let winner = this.logic.winner();
    if (winner)
      this.props.setWinner(winner)
    else {
      if (prevProps.orientation !== this.props.orientation) 
	if (this.logic.turnColor() !== this.props.orientation) 
          this.playWinningMoveIn500ms()
    }
  }
  
  // https://github.com/ornicar/chessground/blob/master/src/state.ts
  // https://github.com/ornicar/chessground/blob/master/src/config.ts
  render() {
    console.log(this.state);
    console.log(`Winning color: ${positions[this.logic.fen()]}`)
    let min_dimension = Math.min(window.innerWidth, window.innerHeight)
    let size = Math.min(512, min_dimension - 132 - 30)
    // let size = Math.min(512, min_dimension * 0.7)
    console.log(`size is ${size}`);
    return (
      <Chessground
        width={size}
        height={size}
        orientation={this.props.orientation}
        turnColor={this.logic.turnColor()}
        movable={this.logic.movable()}
        lastMove={this.state.lastMove}
        fen={this.state.fen}
        onMove={this.onMove}
        addPieceZIndex={true}
        draggable={this.draggable}
        premovable={this.premovable}
        style={{
          minWidth: `${size}px`,
        }}
      />
    )
  }
}

export default Game;
